import { render, staticRenderFns } from "./AnagraficaBarche.vue?vue&type=template&id=75174406&scoped=true&"
import script from "./AnagraficaBarche.vue?vue&type=script&lang=js&"
export * from "./AnagraficaBarche.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75174406",
  null
  
)

export default component.exports